import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    position: relative;\n    border-radius: 9999px;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    overflow: hidden;\n    user-select: none;\n    &:before {\n        content: '!';\n    }\n\n    ", "\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { marginAttributes } from '../../system';
import { getPropsBlocker } from '../../utils';
var propertyList = {};

var getRootBaseStyle = function getRootBaseStyle(_ref) {
  var theme = _ref.theme;
  return theme.componentOverrides.Indicator.Root.base;
};

export var IndicatorRoot = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject(), getRootBaseStyle, marginAttributes);